import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { APP_CONFIG } from '../../global/config/config.token';
import { AppConfig } from '../../global/config/app.config';
import { LookupItem } from '../../global/model/SearchModel';
import { VendorLookups } from '../models/VendorLookups';
import { VendorViewModel, VendorW9ViewModel } from '../models/VendorViewModel';

@Injectable({
  providedIn: 'root',
})
export class AddUpdateVendorService {
  constructor(private http: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig) {
  }

  getVendorLookups(campaignId: number): Observable<VendorLookups> {
    return this.http.get<VendorLookups>(`${this.config.apiUrl}vendor/vendor-lookups?campaignId=${campaignId}&childCampaignId=0`, { withCredentials: true });
  }
  getVendor(vendorId: string, campaignId: number): Observable<VendorViewModel> {
    return this.http.get<VendorViewModel>(`${this.config.apiUrl}vendor/vendordetails?vendorId=${vendorId}&campaignId=${campaignId}`, { withCredentials: true });
  }
  saveVendor(request: VendorViewModel): Observable<string> {
    return this.http.post<string>(`${this.config.apiUrl}vendor/vendor-addupdate`, request, { withCredentials: true , responseType: 'text' as 'json'});
  }
  getVendorW9s(vendorId: string): Observable<VendorW9ViewModel[]> {
    return this.http.get<VendorW9ViewModel[]>(`${this.config.apiUrl}vendor/w9s-get?vendorId=${vendorId}`, { withCredentials: true });
  }
  downloadW9(filePath: string) {
    return this.http.get(`${this.config.apiUrl}vendor/w9s-download?filePath=${filePath}`, { responseType: 'blob', withCredentials: true});
  }
  addw9s(request: FormData): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}vendor/w9s-add`, request, { withCredentials: true });
  }
  deletew9s(attachmentId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}vendor/w9s-delete?attachmentId=${attachmentId}`, '', { withCredentials: true });
  }
}
